var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_9996_23998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 21V9H11.25C10.0078 9 9 7.99219 9 6.75V1.5H3C2.17031 1.5 1.5 2.17031 1.5 3V21C1.5 21.8297 2.17031 22.5 3 22.5H15C15.8297 22.5 16.5 21.8297 16.5 21ZM16.4766 7.5C16.4438 7.36875 16.3781 7.24688 16.2797 7.15313L10.8469 1.72031C10.7484 1.62188 10.6313 1.55625 10.5 1.52344V6.75C10.5 7.1625 10.8375 7.5 11.25 7.5H16.4766ZM0 3C0 1.34531 1.34531 0 3 0H10.3172C10.9125 0 11.4844 0.239063 11.9062 0.660938L17.3391 6.08906C17.7609 6.51094 18 7.08281 18 7.67813V21C18 22.6547 16.6547 24 15 24H3C1.34531 24 0 22.6547 0 21V3Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9996_23998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconBlack);
export default __webpack_public_path__ + "static/media/FileIconBlack.8e5530cf4e6a8cb532bba38d4892218b.svg";
export { ForwardRef as ReactComponent };